/**
 * The in-house analyses that have their own queue and entry page under
 * `/analytics/<slug>`. Each fulfils requests of one test template, matched by
 * the template's code. Order is display order (sidebar, overview tiles).
 */
export type AnalysisSlug =
  | "biogenic-amines"
  | "extracellular-amines"
  | "lps-endotoxin";

export interface AnalysisDefinition {
  slug: AnalysisSlug;
  name: string;
  /** Compact label for tables that list several analyses side by side. */
  shortName: string;
  templateCode: string;
}

export const ANALYSES: AnalysisDefinition[] = [
  {
    slug: "biogenic-amines",
    name: "Biogenic amines",
    shortName: "BA",
    templateCode: "BA",
  },
  {
    slug: "extracellular-amines",
    name: "Extracellular amines",
    shortName: "EBA",
    templateCode: "EBA",
  },
  {
    slug: "lps-endotoxin",
    name: "In-house LAL",
    shortName: "LAL",
    templateCode: "LAL",
  },
];

export function findAnalysis(slug: string): AnalysisDefinition | undefined {
  return ANALYSES.find((analysis) => analysis.slug === slug);
}
